(function () {
  'use strict';
  function normalized(text) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function hideDuplicate(node) {
    node.hidden = true;
    node.setAttribute('data-lfp-description-duplicate', '');
  }
  function clean(scope) {
    scope.querySelectorAll('[data-lfp-description-cleanup]').forEach(function (description) {
      // Only exact standalone general messages; mixed product copy is retained.
      var standalone = [
        /^plazo (?:segun|segn) disponibilidad:\s*stock 24\s*[-–]\s*48 h\s*(?:[·.]\s*)?otros articulos 7\s*[-–]\s*14 dias habiles\.?$/,
        /^devoluciones 15 dias\.?$/,
        /^pago 100\s*% seguro\.?$/
      ];
      description.querySelectorAll('p, li, div').forEach(function (node) {
        if (node.querySelector('p, li, div, img, video, iframe, input, button, select, table')) return;
        var text = normalized(node.textContent);
        if (standalone.some(function (pattern) { return pattern.test(text); })) hideDuplicate(node);
      });
      // Recognized legacy card only. Unknown rows/media prevent whole-card hiding.
      description.querySelectorAll('.ms-trust, .lff-trust').forEach(function (legacy) {
        if (legacy.querySelector('img, video, iframe, input, button, select, table')) return;
        var rows = Array.from(legacy.querySelectorAll('.ms-trust__row'));
        if (rows.length < 3) return;
        function isKnown(row) {
          var text = normalized(row.textContent);
          return /^envio gratis en espana en pedidos de 100 € o mas$/.test(text) ||
            /^cambios y devoluciones en 14 dias [—–-] sin complicaciones$/.test(text) ||
            /^pago 100\s*% seguro(?:\s*[·.]\s*pago 100\s*% seguro)?$/.test(text) ||
            /^¿dudas con la talla\? consulta la guia en las fotos del producto$/.test(text) ||
            /^plazos segun disponibilidad del producto\s*algunos articulos en stock se gestionan aproximadamente en 24\s*[-–]\s*48 h; otros pueden requerir 7\s*[-–]\s*14 dias habiles\. estos plazos son orientativos y no constituyen una fecha de entrega garantizada\.$/.test(text);
        }
        if (rows.every(isKnown)) hideDuplicate(legacy);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { clean(document); });
  else clean(document);
  document.addEventListener('shopify:section:load', function (event) { clean(event.target); });
})();
